<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import CompetitorList from "./partials/CompetitorList.vue";
import {useStore} from "vuex";
import {computed, watch} from "vue";
import CompetitorSelector from "@/components/competition/partials/CompetitorSelector.vue";
import CompetitorDetails from "@/components/competition/partials/CompetitorDetails.vue";
import HelpButton from "@/components/global-themed/buttons/HelpButton.vue";

const props = defineProps({
  competitorId: {
    type: Number,
    required: false,
    default: undefined,
  }
})

const store = useStore();

const competitorId = computed(() => props.competitorId);

watch(competitorId, function (newId) {
  store.dispatch('competitionV2/setCompetitorId', newId)
}, {
  immediate: true,
})

</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-8">
      <div class="tw-flex tw-space-x-8 tw-items-center">
        <h1 class="tw-text-4.5xl tw-text-font-primary tw-font-bold tw-font-sans">
          Competitor Analysis
        </h1>
      </div>

      <HelpButton video-url="https://player.vimeo.com/video/946977290?h=1a515432cd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" />
    </div>
    <div class="tw-flex tw-gap-8">
      <div class="tw-max-w-[27rem] tw-flex-0 tw-bg-white tw-rounded-lg tw-h-auto tw-self-start">
        <div class="tw-p-8 tw-border-b">
          <h3 class="tw-text-2.5xl tw-font-semibold tw-mb-8 tw-text-font-primary tw-font-sans tw-antialiased">
            Tracked Competitors
          </h3>
          <DefaultButton
            as="a"
            href="/competition/compare"
          >
            <svg-vue
              class="tw-mr-3 tw-h-6 tw-w-6"
              icon="icons/travel-a-to-b"
            />
            <span class="tw-font-normal">Compare Competitors</span>
          </DefaultButton>
        </div>
        <CompetitorList class="tw-p-8" />
      </div>

      <div class="tw-w-full tw-flex tw-flex-col tw-gap-8">
        <div class="tw-bg-white tw-rounded-lg tw-p-8">
          <CompetitorSelector />
        </div>

        <div
          class="tw-bg-white tw-rounded-lg"
        >
          <CompetitorDetails />
        </div>
      </div>
    </div>
  </div>
</template>
